// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"124":"vendor-chat","403":"vendor-scheduler-87f2a00f","736":"vendor-scheduler-f89d183e","768":"vendor-editors"}[chunkId] || chunkId) + "." + {"98":"6d836ea0","124":"22ed32d6","403":"bd95dd82","736":"feb06886","768":"ac6116b4"}[chunkId] + ".chunk.js";
};